import React, { useEffect } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputBase } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { getLabel } from '@shared/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function Search({ onChangeSearch, value = '', placeholder = getLabel('search'), icon = <SearchIcon /> }) {
  const classes = useStyles();
  const [search, setSearch] = React.useState(value);

  const onChange = (event) => {
    setSearch(event.target.value);
    onChangeSearch(event.target.value);
  };

  const onCleanSearch = () => {
    setSearch('');
    onChangeSearch('');
  };

  useEffect(() => {
    setSearch(value);
  }, [value]);

  return (
    <div style={{ display: 'inline-block' }}>
      <InputBase className={classes.input} placeholder={placeholder} value={search} onChange={onChange} />
      <IconButton type="submit" className={classes.iconButton} aria-label="search" onClick={onCleanSearch}>
        {search ? <CloseIcon /> : icon}
      </IconButton>
    </div>
  );
}

Search.propTypes = {
  onChangeSearch: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
};
